import React, { useContext } from 'react';
import 'assets/sass/dashboard/layout/HeaderPrice.scss';
import {MoneyField} from "buenLib/components/MoneyField";
import {Currency} from "buenLib/domain/Currency";
import { AppContext } from 'app/state/AppContext';


export function HeaderPrice({selectedCurrency}) {
    const { marketIdentifiers, marketTickers } = useContext(AppContext);

    function priceCurrency(marketTicker) {
        let bidCurrency = marketTicker.bidCurrency();
        let askCurrency = marketTicker.askCurrency();
        return Currency.priceCurrency(bidCurrency, askCurrency)
    }

    function renderMarketTicker(marketIdentifier) {
        let marketTicker = marketTickers[marketIdentifier].get();
        if (!marketTicker) return null;

        return <div key={marketIdentifier} className="price">
            <div className="price-label">{marketTicker.formattedMarketIdentifier()}</div>
            <div className="price-price">
                <div className="price-value">
                    <MoneyField value={marketTicker.purchasePrice()}
                                currency={priceCurrency(marketTicker)}/>
                    <span> / </span>
                    <MoneyField value={marketTicker.sellingPrice()}
                                currency={priceCurrency(marketTicker)}/>
                </div>
            </div>
        </div>
    }

    function renderTickers() {
        const filteredMarkets = marketIdentifiers.filter(((id) => id.includes(selectedCurrency)));

        const filteredTickers = Object.keys(marketTickers.get())
            .filter(marketIdentifier => filteredMarkets.includes(marketIdentifier))
            .map(marketIdentifier => renderMarketTicker(marketIdentifier));

        return filteredTickers;
    }

    if (!marketTickers.get()) {
        return <div className="dashboard-header--price empty">Cargando…</div>
    }
    return <div className="dashboard-header--price">
        <div className="grid">
            {renderTickers()}
        </div>
    </div>;
}
